import React from 'react';
import CompanySearch from './CompanySearch'
import {
    useHistory
  } from "react-router-dom";
  
  function Home()  {

    let history = useHistory();

    function onSubmit()
    {
      history.push("/find");
    }

    return <div className="App container">
            <header className="App-header">
            <img src="locallygives-logo-lg.png" className="App-logo" alt="logo" />
            <p>
                Search for the company you want to support
            </p>       
            </header>
            <div class="row">
            <CompanySearch onSubmit={onSubmit} />
            </div>
        </div>
    ;
  }

 
  export default Home;


